import { __decorate, __metadata } from "tslib";
import { event, changedAttribute, elementDefine, eventShadow, eventWindow, mutationObserverLight, onConnectedAfter, onConnectedBodyShadow, queryShadow } from "@dooboostore/simple-web-component";
function resolveBound(ref, states, fallback) {
  if (ref == null || ref === "")
    return fallback;
  const n = Number(ref);
  if (Number.isFinite(n))
    return n;
  const t = states.find((s) => s.name === ref);
  return t ? t.value : fallback;
}
function snapValue(v, gmin, step) {
  const st = step > 0 ? step : 1;
  return gmin + Math.round((v - gmin) / st) * st;
}
function clampThumbs(states, mins, maxs, gmin, gmax) {
  const n = states.length;
  if (!n)
    return;
  for (let pass = 0; pass < n + 1; pass++) {
    let changed = false;
    for (let i = 0; i < n; i++) {
      const lo = resolveBound(mins[i], states, gmin);
      const hi = resolveBound(maxs[i], states, gmax);
      const lo2 = Math.min(lo, hi);
      const hi2 = Math.max(lo, hi);
      const nv = snapValue(Math.min(Math.max(states[i].value, lo2), hi2), gmin, states[i].step);
      if (nv !== states[i].value) {
        states[i].value = nv;
        changed = true;
      }
    }
    if (!changed)
      break;
  }
}
function nearestThumbIndex(states, v) {
  let best = 0;
  let bestD = Infinity;
  for (let i = 0; i < states.length; i++) {
    const d = Math.abs(states[i].value - v);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  }
  return best;
}
function translateStates(states, names, delta, mins, maxs, gmin, gmax) {
  if (!delta || !names.size)
    return 0;
  let loD = -Infinity;
  let hiD = Infinity;
  for (let i = 0; i < states.length; i++) {
    if (!names.has(states[i].name))
      continue;
    const lo = resolveBound(mins[i], states, gmin);
    const hi = resolveBound(maxs[i], states, gmax);
    loD = Math.max(loD, Math.min(lo, hi) - states[i].value);
    hiD = Math.min(hiD, Math.max(lo, hi) - states[i].value);
  }
  const d = Math.min(Math.max(delta, loD), hiD);
  if (!d)
    return 0;
  for (let i = 0; i < states.length; i++) {
    if (!names.has(states[i].name))
      continue;
    states[i].value = snapValue(states[i].value + d, gmin, states[i].step);
  }
  return d;
}
const tagName = "range-slider";
function num(v, fb) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fb;
}
var RangeSlider_default = (w) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
  const existing = w.customElements.get(tagName);
  if (existing)
    return existing;
  let RangeSliderImpl = class RangeSliderImpl extends w.HTMLElement {
    constructor() {
      super(...arguments);
      Object.defineProperty(this, "_min", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
      });
      Object.defineProperty(this, "_max", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
      });
      Object.defineProperty(this, "_step", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
      });
      Object.defineProperty(this, "_mode", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "range"
      });
      Object.defineProperty(this, "_orientation", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "horizontal"
      });
      Object.defineProperty(this, "_low", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
      });
      Object.defineProperty(this, "_high", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
      });
      Object.defineProperty(this, "_drag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: null
      });
      Object.defineProperty(this, "_syncing", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
      });
      Object.defineProperty(this, "_internals", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: null
      });
      Object.defineProperty(this, "_thumbs", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: null
      });
      Object.defineProperty(this, "_groups", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: null
      });
      Object.defineProperty(this, "_dragThumb", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: null
      });
      Object.defineProperty(this, "_dragGroup", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: null
      });
      Object.defineProperty(this, "track", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
      Object.defineProperty(this, "fill", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
      Object.defineProperty(this, "thumbMin", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
      Object.defineProperty(this, "thumbMax", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
      Object.defineProperty(this, "thumbBox", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
    }
    static get formAssociated() {
      return true;
    }
    // ---------- input-like API ----------
    get min() {
      return this._min;
    }
    set min(v) {
      this.setAttr("min", String(v));
    }
    get max() {
      return this._max;
    }
    set max(v) {
      this.setAttr("max", String(v));
    }
    get step() {
      return this._step;
    }
    set step(v) {
      this.setAttr("step", String(v));
    }
    get mode() {
      return this._mode;
    }
    set mode(v) {
      this.setAttr("mode", v);
    }
    get orientation() {
      return this._orientation;
    }
    set orientation(v) {
      this.setAttr("orientation", v);
    }
    get minValue() {
      if (this._thumbs?.length)
        return Math.min(...this._thumbs.map((t) => t.value));
      return this._mode === "single" ? this._low : this._low;
    }
    set minValue(v) {
      this.setLow(Number(v));
    }
    get maxValue() {
      if (this._thumbs?.length)
        return Math.max(...this._thumbs.map((t) => t.value));
      return this._mode === "single" ? this._low : this._high;
    }
    set maxValue(v) {
      if (this._mode === "single")
        this.setLow(Number(v));
      else
        this.setHigh(Number(v));
    }
    /** 썸 자식 있음: {name: 값} 객체 / 레거시 range: 차이값 문자열 */
    get value() {
      if (this._thumbs?.length) {
        const o = {};
        for (const t of this._thumbs)
          o[t.name] = t.value;
        return o;
      }
      return String(this._mode === "single" ? this._low : this._high - this._low);
    }
    set value(v) {
      if (v != null && typeof v === "object" && this._thumbs?.length) {
        this.setValues(v);
        return;
      }
      const n = Number(v);
      if (!Number.isFinite(n))
        return;
      if (this._mode === "single")
        this.setLow(n);
      else
        this.setHigh(this._low + n);
    }
    get avgValue() {
      if (this._thumbs?.length)
        return this._thumbs.reduce((s, t) => s + t.value, 0) / this._thumbs.length;
      return (this.minValue + this.maxValue) / 2;
    }
    setValues(values) {
      if (!this._thumbs?.length || !values)
        return;
      for (const t of this._thumbs) {
        if (typeof values[t.name] === "number" && Number.isFinite(values[t.name]))
          t.value = values[t.name];
      }
      this.clampMulti();
      this.reflectMulti();
      this.paint();
    }
    // ---------- 렌더 ----------
    render() {
      return `
        <style>
          :host { display: inline-block; touch-action: none; user-select: none; -webkit-user-select: none; width: 100%; height: 28px; }
          :host([orientation="vertical"]) { width: 28px; height: 200px; }
          :host(.has-groups) { height: 44px; }
          :host(.has-groups[orientation="vertical"]) { width: 44px; height: 200px; }
          .rs-track { position: relative; width: 100%; height: 100%; cursor: pointer; }
          .rs-rail { position: absolute; background: #e2e8f0; border-radius: 999px; }
          :host([orientation="horizontal"]) .rs-rail { left: 0; right: 0; top: 50%; height: 6px; transform: translateY(-50%); }
          :host([orientation="vertical"]) .rs-rail { top: 0; bottom: 0; left: 50%; width: 6px; transform: translateX(-50%); }
          .rs-fill { position: absolute; background: #6366f1; border-radius: 999px; }
          .rs-thumb {
            position: absolute; width: 18px; height: 18px; border-radius: 50%;
            background: #fff; border: 2px solid #6366f1; box-shadow: 0 1px 3px rgba(0,0,0,.2);
            cursor: grab; z-index: 2; outline: none;
          }
          .rs-thumb:focus-visible { box-shadow: 0 0 0 3px rgba(99,102,241,.35); }
          .rs-thumb:active { cursor: grabbing; }
          #rs-groups { position: absolute; inset: 0; pointer-events: none; z-index: 1; }
          .rs-group-bar {
            position: absolute; pointer-events: auto; cursor: grab;
            border: 1.5px solid #7c3aed; border-top: none; border-radius: 0 0 6px 6px;
            background: rgba(124,58,237,0.07);
          }
          .rs-group-bar:active { cursor: grabbing; }
          .rs-group-bar:focus-visible { outline: 2px solid #7c3aed; outline-offset: 1px; }
          :host([orientation="horizontal"]) .rs-group-bar { height: 12px; bottom: 0; }
          :host([orientation="vertical"]) .rs-group-bar { width: 12px; right: 0; border: 1.5px solid #7c3aed; border-left: none; border-radius: 0 6px 6px 0; background: rgba(124,58,237,0.07); }
          :host([orientation="vertical"]) .rs-group-bar { height: auto; }
          .rs-group-label {
            position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
            font-size: 9px; font-weight: 800; color: #7c3aed; white-space: nowrap; line-height: 1;
            pointer-events: none;
          }
        </style>
        <div class="rs-track" id="rs-track">
          <div class="rs-rail"></div>
          <div class="rs-fill" id="rs-fill"></div>
          <div class="rs-thumb" id="rs-min" tabindex="0" role="slider" aria-label="min"></div>
          <div class="rs-thumb" id="rs-max" tabindex="0" role="slider" aria-label="max"></div>
          <div id="rs-thumbs"></div>
          <div id="rs-groups"></div>
        </div>
      `;
    }
    onConnected() {
      try {
        this._internals = this.attachInternals?.() ?? null;
      } catch {
        this._internals = null;
      }
      this.readAllAttributes();
      this.parseThumbs();
      this.paint();
    }
    // ---------- 속성 동기화 ----------
    onMinChanged(v) {
      this._min = Number.isFinite(v) ? v : 0;
      if (this._thumbs?.length) {
        this.clampMulti();
        this.paint();
      } else
        this.clampAll(false);
    }
    onMaxChanged(v) {
      this._max = Number.isFinite(v) ? v : 100;
      if (this._thumbs?.length) {
        this.clampMulti();
        this.paint();
      } else
        this.clampAll(false);
    }
    onStepChanged(v) {
      this._step = Number.isFinite(v) && v > 0 ? v : 1;
      if (this._thumbs?.length) {
        this.clampMulti();
        this.paint();
      } else
        this.clampAll(false);
    }
    onModeChanged(v) {
      this._mode = v === "single" ? "single" : "range";
      this.clampAll(false);
    }
    onOrientationChanged(v) {
      this._orientation = v === "vertical" ? "vertical" : "horizontal";
      this.paint();
    }
    onMinValueChanged(v) {
      if (this._syncing || !Number.isFinite(v))
        return;
      this.setLow(v, true);
    }
    onMaxValueChanged(v) {
      if (this._syncing || !Number.isFinite(v))
        return;
      if (this._mode === "single")
        this.setLow(v, true);
      else
        this.setHigh(v, true);
    }
    onValueChanged(v) {
      if (this._syncing)
        return;
      const n = Number(v);
      if (!Number.isFinite(n))
        return;
      if (this._mode === "single")
        this.setLow(n, true);
      else
        this.setHigh(this._low + n, true);
    }
    // ---------- 드래그 ----------
    onMinDown(e) {
      e.preventDefault();
      this._drag = "min";
      try {
        e.target.setPointerCapture?.(e.pointerId);
      } catch {
      }
    }
    onMaxDown(e) {
      e.preventDefault();
      this._drag = this._mode === "single" ? "min" : "max";
      try {
        e.target.setPointerCapture?.(e.pointerId);
      } catch {
      }
    }
    onTrackDown(e) {
      if (e.target?.closest?.(".rs-thumb, .rs-group-bar"))
        return;
      const v = this.posToValue(e);
      if (this._thumbs?.length) {
        const i = nearestThumbIndex(this._thumbs, v);
        const nm = this._thumbs[i].name;
        this.setThumbValue(nm, v);
        this._dragThumb = null;
        this.emit("input", nm);
        this.emit("change", nm);
        return;
      }
      if (this._mode === "single") {
        this.setLow(v);
      } else {
        const dLow = Math.abs(v - this._low);
        const dHigh = Math.abs(v - this._high);
        if (dLow <= dHigh)
          this.setLow(v);
        else
          this.setHigh(v);
      }
      this._drag = null;
      this.emit("input");
      this.emit("change");
    }
    onDragMove(e) {
      if (this._dragGroup && this._thumbs?.length) {
        e.preventDefault();
        const v2 = this.posToValue(e);
        const d = v2 - this._dragGroup.lastV;
        this._dragGroup.lastV = v2;
        const g = this._dragGroup.group;
        this.moveGroup(g, d);
        this.emit("input", `group:${g}`);
        return;
      }
      if (this._dragThumb && this._thumbs?.length) {
        e.preventDefault();
        this.setThumbValue(this._dragThumb, this.posToValue(e));
        this.emit("input", this._dragThumb);
        return;
      }
      if (!this._drag)
        return;
      e.preventDefault();
      const v = this.posToValue(e);
      if (this._mode === "single" || this._drag === "min")
        this.setLow(v);
      else
        this.setHigh(v);
      this.emit("input");
    }
    onDragUp() {
      if (this._dragGroup) {
        const g = this._dragGroup.group;
        this._dragGroup = null;
        this.emit("change", `group:${g}`);
        return;
      }
      if (this._dragThumb) {
        const nm = this._dragThumb;
        this._dragThumb = null;
        this.emit("change", nm);
        return;
      }
      if (!this._drag)
        return;
      this._drag = null;
      this.emit("change");
    }
    onDragCancel() {
      if (this._dragGroup) {
        const g = this._dragGroup.group;
        this._dragGroup = null;
        this.emit("change", `group:${g}`);
        return;
      }
      if (this._dragThumb) {
        const nm = this._dragThumb;
        this._dragThumb = null;
        this.emit("change", nm);
        return;
      }
      if (!this._drag)
        return;
      this._drag = null;
      this.emit("change");
    }
    onMinKey(e) {
      const d = this.keyDelta(e);
      if (d === null)
        return;
      e.preventDefault();
      this.setLow(this._low + d);
      this.emit("input");
      this.emit("change");
    }
    onMaxKey(e) {
      const d = this.keyDelta(e);
      if (d === null)
        return;
      e.preventDefault();
      if (this._mode === "single")
        this.setLow(this._low + d);
      else
        this.setHigh(this._high + d);
      this.emit("input");
      this.emit("change");
    }
    // ---------- 내부 ----------
    setAttr(name, val) {
      this._syncing = true;
      try {
        this.setAttribute(name, val);
      } finally {
        this._syncing = false;
      }
      this.readAllAttributes();
      this.paint();
    }
    readAllAttributes() {
      this._min = num(this.getAttribute("min"), 0);
      this._max = num(this.getAttribute("max"), 100);
      if (this._max <= this._min)
        this._max = this._min + 1;
      const st = num(this.getAttribute("step"), 1);
      this._step = st > 0 ? st : 1;
      this._mode = this.getAttribute("mode") === "single" ? "single" : "range";
      this._orientation = this.getAttribute("orientation") === "vertical" ? "vertical" : "horizontal";
      const lo = this.getAttribute("min-value");
      const hi = this.getAttribute("max-value");
      const vv = this.getAttribute("value");
      if (lo !== null)
        this._low = this.snap(num(lo, this._min));
      else if (vv !== null && this._mode === "single")
        this._low = this.snap(num(vv, this._min));
      else if (this._low === void 0)
        this._low = this._min;
      if (this._mode === "single") {
        this._high = this._max;
      } else if (hi !== null) {
        this._high = this.snap(num(hi, this._max));
      } else if (vv !== null && lo !== null) {
        this._high = this.snap(this._low + num(vv, 0));
      }
      this.clampAll(false);
    }
    snap(v) {
      const steps = Math.round((v - this._min) / this._step);
      return this._min + steps * this._step;
    }
    setLow(v, fromAttr = false) {
      const nv = Math.min(Math.max(this.snap(v), this._min), this._mode === "single" ? this._max : this._high);
      if (nv === this._low && !fromAttr)
        return;
      this._low = nv;
      this.afterChange(fromAttr, "min");
    }
    setHigh(v, fromAttr = false) {
      const nv = Math.min(Math.max(this.snap(v), this._low), this._max);
      if (nv === this._high && !fromAttr)
        return;
      this._high = nv;
      this.afterChange(fromAttr, "max");
    }
    clampAll(reflect = true) {
      if (this._max <= this._min)
        this._max = this._min + 1;
      this._low = Math.min(Math.max(this._low ?? this._min, this._min), this._max);
      this._high = Math.min(Math.max(this._high ?? this._max, this._low), this._max);
      if (this._mode === "single")
        this._high = this._max;
      if (reflect)
        this.reflect();
      this.paint();
    }
    afterChange(fromAttr, which) {
      if (!fromAttr)
        this.reflect(which);
      this.paint();
    }
    reflect(which) {
      this._syncing = true;
      try {
        this.setAttribute("min-value", String(this._low));
        if (this._mode === "range")
          this.setAttribute("max-value", String(this._high));
        else
          this.removeAttribute("max-value");
        this.setAttribute("value", String(this._mode === "single" ? this._low : this._high - this._low));
      } finally {
        this._syncing = false;
      }
      try {
        this._internals?.setFormValue?.(this.value);
      } catch {
      }
    }
    emit(type, changed) {
      const multi = !!this._thumbs?.length;
      this.dispatchEvent(new w.CustomEvent(type, {
        bubbles: true,
        composed: true,
        detail: multi ? {
          values: this.value,
          minValue: this.minValue,
          maxValue: this.maxValue,
          avgValue: this.avgValue,
          changed,
          mode: "multi"
        } : {
          minValue: this._mode === "single" ? this._low : this._low,
          maxValue: this._mode === "single" ? this._low : this._high,
          value: this._mode === "single" ? this._low : this._high - this._low,
          mode: this._mode
        }
      }));
    }
    frac() {
      const span = this._max - this._min || 1;
      return { lo: (this._low - this._min) / span, hi: (this._high - this._min) / span };
    }
    paint() {
      if (this._thumbs?.length) {
        this.paintMulti();
        return;
      }
      this.paintLegacy();
    }
    paintLegacy() {
      if (!this.track || !this.fill || !this.thumbMin || !this.thumbMax)
        return;
      const { lo, hi } = this.frac();
      const loP = Math.min(Math.max(lo, 0), 1) * 100;
      const hiP = Math.min(Math.max(hi, 0), 1) * 100;
      const isV = this._orientation === "vertical";
      if (isV) {
        this.fill.style.left = "50%";
        this.fill.style.transform = "translateX(-50%)";
        this.fill.style.width = "6px";
        this.fill.style.bottom = `${this._mode === "single" ? 0 : loP}%`;
        this.fill.style.height = `${this._mode === "single" ? loP : hiP - loP}%`;
        this.thumbMin.style.left = "50%";
        this.thumbMin.style.bottom = `${loP}%`;
        this.thumbMin.style.transform = "translate(-50%, 50%)";
        this.thumbMax.style.left = "50%";
        this.thumbMax.style.bottom = `${hiP}%`;
        this.thumbMax.style.transform = "translate(-50%, 50%)";
        this.thumbMax.style.display = this._mode === "single" ? "none" : "";
      } else {
        this.fill.style.bottom = "";
        this.fill.style.transform = "";
        this.fill.style.width = "";
        this.fill.style.height = "6px";
        this.fill.style.top = "50%";
        this.fill.style.transform = "translateY(-50%)";
        this.fill.style.left = `${this._mode === "single" ? 0 : loP}%`;
        this.fill.style.width = `${this._mode === "single" ? loP : hiP - loP}%`;
        this.thumbMin.style.bottom = "";
        this.thumbMin.style.left = `${loP}%`;
        this.thumbMin.style.top = "50%";
        this.thumbMin.style.transform = "translate(-50%, -50%)";
        this.thumbMax.style.bottom = "";
        this.thumbMax.style.left = `${hiP}%`;
        this.thumbMax.style.top = "50%";
        this.thumbMax.style.transform = "translate(-50%, -50%)";
        this.thumbMax.style.display = this._mode === "single" ? "none" : "";
      }
      this.thumbMin.setAttribute("aria-valuemin", String(this._min));
      this.thumbMin.setAttribute("aria-valuemax", String(this._mode === "single" ? this._max : this._high));
      this.thumbMin.setAttribute("aria-valuenow", String(this._low));
      this.thumbMax.setAttribute("aria-valuemin", String(this._low));
      this.thumbMax.setAttribute("aria-valuemax", String(this._max));
      this.thumbMax.setAttribute("aria-valuenow", String(this._high));
    }
    posToValue(e) {
      const r = this.track.getBoundingClientRect();
      const isV = this._orientation === "vertical";
      const ratio = isV ? 1 - Math.min(Math.max((e.clientY - r.top) / (r.height || 1), 0), 1) : Math.min(Math.max((e.clientX - r.left) / (r.width || 1), 0), 1);
      return this._min + ratio * (this._max - this._min);
    }
    keyDelta(e) {
      const big = this._step * 10;
      switch (e.key) {
        case "ArrowUp":
        case "ArrowRight":
          return this._step;
        case "ArrowDown":
        case "ArrowLeft":
          return -this._step;
        case "PageUp":
          return big;
        case "PageDown":
          return -big;
        case "Home":
          if (e.target === this.thumbMin) {
            this.setLow(this._min);
            this.emit("input");
            this.emit("change");
          } else {
            this.setHigh(this._min);
            this.emit("input");
            this.emit("change");
          }
          return null;
        case "End":
          if (e.target === this.thumbMin) {
            this.setLow(this._mode === "single" ? this._max : this._high);
            this.emit("input");
            this.emit("change");
          } else {
            this.setHigh(this._max);
            this.emit("input");
            this.emit("change");
          }
          return null;
        default:
          return null;
      }
    }
    // ---------- 선언형 썸 (multi) ----------
    /**
     * 선언형 구조를 문서 순서대로 읽음:
     * - 직접 자식 <thumb name=...> → 단독 썸
     * - <thumb-group label="" color=""> 안의 <thumb> → 같은 그룹 (브래킷+팬 단위)
     * 소속은 중첩 구조로만 결정 (썸의 group 속성은 무시 — 단일 진실원천).
     */
    readThumbStructure() {
      const els = [];
      const groups = [];
      const owner = /* @__PURE__ */ new Map();
      let gi = 0;
      for (const node of Array.from(this.childNodes)) {
        if (node.nodeType !== 1)
          continue;
        const el = node;
        const tag = (el.tagName || "").toLowerCase();
        if (tag === "thumb-group") {
          const id = `g${gi++}`;
          groups.push({
            id,
            label: el.getAttribute("label") || `\uADF8\uB8F9 ${gi}`,
            color: el.getAttribute("color") ?? void 0
          });
          for (const sub of Array.from(el.children)) {
            if ((sub.tagName || "").toLowerCase() !== "thumb")
              continue;
            if (!(sub.getAttribute("name") || "").trim())
              continue;
            els.push(sub);
            owner.set(sub, id);
          }
        } else if (tag === "thumb") {
          if (!(el.getAttribute("name") || "").trim())
            continue;
          els.push(el);
          owner.set(el, void 0);
        }
      }
      return { els, groups, owner };
    }
    parseThumbs() {
      const { els, groups, owner } = this.readThumbStructure();
      if (!els.length) {
        if (this._thumbs?.length) {
          this._thumbs = null;
          this._groups = null;
          if (this.thumbBox)
            this.thumbBox.innerHTML = "";
          const gb = this.shadowRoot?.querySelector("#rs-groups");
          if (gb)
            gb.innerHTML = "";
          this.classList.remove("has-groups");
          if (this.thumbMin)
            this.thumbMin.style.display = "";
          if (this.thumbMax)
            this.thumbMax.style.display = "";
          this.paint();
        } else {
          this._thumbs = null;
          this._groups = null;
        }
        return;
      }
      const gkey = groups.map((g) => `${g.id}:${g.label}:${g.color ?? ""}`).join("~");
      const structKey = `${gkey}||` + els.map((el) => [el.getAttribute("name"), el.getAttribute("min"), el.getAttribute("max"), el.getAttribute("step"), el.getAttribute("color"), el.getAttribute("size"), el.getAttribute("fill"), owner.get(el) ?? ""].join("|")).join("~");
      const prevKey = this._thumbs ? this._thumbs._structKey : null;
      if (this._thumbs?.length && prevKey === structKey) {
        let touched = false;
        for (const t of this._thumbs) {
          const raw = t.el.getAttribute("value");
          if (raw !== null) {
            const n2 = Number(raw);
            if (Number.isFinite(n2) && n2 !== t.value) {
              t.value = n2;
              touched = true;
            }
          }
        }
        if (touched) {
          this.clampMulti();
          this.reflectMulti();
          this.paint();
        }
        return;
      }
      const n = els.length;
      const states = els.map((el, i) => {
        const raw = el.getAttribute("value");
        const fb = this._min + (this._max - this._min) * (n === 1 ? 0.5 : i / (n - 1));
        const v = raw !== null && Number.isFinite(Number(raw)) ? Number(raw) : fb;
        const st = num(el.getAttribute("step"), this._step);
        return {
          el,
          name: (el.getAttribute("name") || "").trim(),
          value: v,
          step: st > 0 ? st : this._step,
          minRef: el.getAttribute("min") ?? void 0,
          maxRef: el.getAttribute("max") ?? void 0,
          color: el.getAttribute("color") ?? void 0,
          size: (() => {
            const s = Number(el.getAttribute("size"));
            return Number.isFinite(s) && s >= 10 && s <= 48 ? Math.round(s) : void 0;
          })(),
          fill: el.getAttribute("fill") ?? void 0,
          group: owner.get(el)
        };
      });
      states._structKey = structKey;
      this._thumbs = states;
      this._groups = groups;
      this.buildMultiThumbs();
      this.clampMulti();
      this.reflectMulti();
      this.paint();
    }
    buildMultiThumbs() {
      if (!this.thumbBox || !this._thumbs)
        return;
      this.thumbBox.innerHTML = "";
      const doc = this.thumbBox.ownerDocument;
      for (const t of this._thumbs) {
        const d = doc.createElement("div");
        d.className = "rs-thumb rs-thumb-multi";
        d.dataset.name = t.name;
        d.setAttribute("tabindex", "0");
        d.setAttribute("role", "slider");
        d.setAttribute("aria-label", t.name);
        const bc = t.color ?? (t.group ? this.groupColor(t.group) : void 0);
        if (bc)
          d.style.borderColor = bc;
        if (t.size) {
          d.style.width = `${t.size}px`;
          d.style.height = `${t.size}px`;
        }
        if (t.fill)
          d.style.background = t.fill;
        this.thumbBox.appendChild(d);
      }
      if (this.thumbMin)
        this.thumbMin.style.display = "none";
      if (this.thumbMax)
        this.thumbMax.style.display = "none";
      this.buildGroupBars();
    }
    buildGroupBars() {
      const box = this.shadowRoot?.querySelector("#rs-groups");
      if (!box)
        return;
      box.innerHTML = "";
      const groups = this.groupNames();
      this.classList.toggle("has-groups", groups.length > 0);
      if (!this._thumbs?.length)
        return;
      const doc = box.ownerDocument;
      for (const g of groups) {
        const bar = doc.createElement("div");
        bar.className = "rs-group-bar";
        bar.dataset.group = g;
        bar.setAttribute("tabindex", "0");
        bar.setAttribute("role", "slider");
        bar.setAttribute("aria-label", this.groupLabel(g));
        const gc = this.groupColor(g);
        if (gc) {
          bar.style.borderColor = gc;
          bar.style.background = "transparent";
        }
        const label = doc.createElement("span");
        label.className = "rs-group-label";
        label.textContent = this.groupLabel(g);
        if (gc)
          label.style.color = gc;
        bar.appendChild(label);
        box.appendChild(bar);
      }
    }
    clampMulti() {
      if (!this._thumbs?.length)
        return;
      if (this._max <= this._min)
        this._max = this._min + 1;
      clampThumbs(this._thumbs, this._thumbs.map((t) => t.minRef), this._thumbs.map((t) => t.maxRef), this._min, this._max);
    }
    /** 썸 단독 이동 (제약만 적용, 그룹 전파 없음 — 그룹 이동은 브래킷 드래그) */
    setThumbValue(name, v) {
      if (!this._thumbs?.length)
        return;
      const t = this._thumbs.find((x) => x.name === name);
      if (!t || !Number.isFinite(v))
        return;
      t.value = v;
      this.clampMulti();
      this.reflectMulti();
      this.paint();
    }
    /** 그룹 전체 리지드 이동 (브래킷 드래그용). 달성 델타 반환 */
    moveGroup(group, delta) {
      if (!this._thumbs?.length || !delta)
        return 0;
      const members = new Set(this._thumbs.filter((x) => x.group === group).map((x) => x.name));
      if (!members.size)
        return 0;
      const d = translateStates(this._thumbs, members, delta, this._thumbs.map((x) => x.minRef), this._thumbs.map((x) => x.maxRef), this._min, this._max);
      this.clampMulti();
      this.reflectMulti();
      this.paint();
      return d;
    }
    groupNames() {
      return (this._groups ?? []).map((g) => g.id);
    }
    groupLabel(group) {
      return this._groups?.find((g) => g.id === group)?.label ?? group;
    }
    groupColor(group) {
      return this._groups?.find((g) => g.id === group)?.color;
    }
    reflectMulti() {
      if (!this._thumbs?.length)
        return;
      this._syncing = true;
      try {
        for (const t of this._thumbs) {
          if (t.el.getAttribute("value") !== String(t.value))
            t.el.setAttribute("value", String(t.value));
        }
      } finally {
        this._syncing = false;
      }
      try {
        this._internals?.setFormValue?.(JSON.stringify(this.value));
      } catch {
      }
    }
    multiBound(name, which) {
      if (!this._thumbs?.length)
        return which === "min" ? this._min : this._max;
      const t = this._thumbs.find((x) => x.name === name);
      if (!t)
        return which === "min" ? this._min : this._max;
      return which === "min" ? resolveBound(t.minRef, this._thumbs, this._min) : resolveBound(t.maxRef, this._thumbs, this._max);
    }
    paintMulti() {
      if (!this.track || !this.fill || !this.thumbBox)
        return;
      const vs = this._thumbs.map((t) => t.value);
      const lo = Math.min(...vs);
      const hi = Math.max(...vs);
      const span = this._max - this._min || 1;
      const pct = (v) => Math.min(Math.max((v - this._min) / span, 0), 1) * 100;
      const isV = this._orientation === "vertical";
      if (isV) {
        this.fill.style.left = "50%";
        this.fill.style.transform = "translateX(-50%)";
        this.fill.style.width = "6px";
        this.fill.style.top = "";
        this.fill.style.height = "";
        this.fill.style.bottom = `${pct(lo)}%`;
        this.fill.style.height = `${pct(hi) - pct(lo)}%`;
      } else {
        this.fill.style.bottom = "";
        this.fill.style.height = "6px";
        this.fill.style.top = "50%";
        this.fill.style.transform = "translateY(-50%)";
        this.fill.style.left = `${pct(lo)}%`;
        this.fill.style.width = `${pct(hi) - pct(lo)}%`;
      }
      for (const t of this._thumbs) {
        const d = this.thumbBox.querySelector(`[data-name="${t.name}"]`);
        if (!d)
          continue;
        const p = pct(t.value);
        if (isV) {
          d.style.left = "50%";
          d.style.bottom = `${p}%`;
          d.style.top = "";
          d.style.transform = "translate(-50%, 50%)";
        } else {
          d.style.bottom = "";
          d.style.left = `${p}%`;
          d.style.top = "50%";
          d.style.transform = "translate(-50%, -50%)";
        }
        d.setAttribute("aria-valuemin", String(this.multiBound(t.name, "min")));
        d.setAttribute("aria-valuemax", String(this.multiBound(t.name, "max")));
        d.setAttribute("aria-valuenow", String(t.value));
      }
      const gbox = this.shadowRoot?.querySelector("#rs-groups");
      if (gbox && this._thumbs) {
        for (const g of this.groupNames()) {
          const bar = gbox.querySelector(`[data-group="${g}"]`);
          if (!bar)
            continue;
          const vs2 = this._thumbs.filter((t) => t.group === g).map((t) => t.value);
          if (!vs2.length)
            continue;
          const loP = pct(Math.min(...vs2));
          const hiP = pct(Math.max(...vs2));
          if (isV) {
            bar.style.bottom = `${loP}%`;
            bar.style.height = `${hiP - loP}%`;
            bar.style.left = "";
          } else {
            bar.style.left = `${loP}%`;
            bar.style.width = `${hiP - loP}%`;
          }
          bar.setAttribute("aria-valuemin", String(Math.min(...vs2)));
          bar.setAttribute("aria-valuemax", String(Math.max(...vs2)));
        }
      }
      const gc0 = this.groupNames().map((g) => this.groupColor(g)).find((c) => !!c);
      this.fill.style.background = gc0 ?? "";
    }
    onMultiThumbDown(e) {
      const th = e.target?.closest?.(".rs-thumb-multi");
      const name = th?.dataset?.name;
      if (!name)
        return;
      e.preventDefault();
      this._dragThumb = name;
      try {
        e.target.setPointerCapture?.(e.pointerId);
      } catch {
      }
    }
    onMultiThumbKey(e) {
      const th = e.target?.closest?.(".rs-thumb-multi");
      const name = th?.dataset?.name;
      if (!name || !this._thumbs?.length)
        return;
      const t = this._thumbs.find((x) => x.name === name);
      if (!t)
        return;
      const big = t.step * 10;
      let handled = true;
      switch (e.key) {
        case "ArrowUp":
        case "ArrowRight":
          this.setThumbValue(name, t.value + t.step);
          break;
        case "ArrowDown":
        case "ArrowLeft":
          this.setThumbValue(name, t.value - t.step);
          break;
        case "PageUp":
          this.setThumbValue(name, t.value + big);
          break;
        case "PageDown":
          this.setThumbValue(name, t.value - big);
          break;
        case "Home":
          this.setThumbValue(name, this.multiBound(name, "min"));
          break;
        case "End":
          this.setThumbValue(name, this.multiBound(name, "max"));
          break;
        default:
          handled = false;
      }
      if (!handled)
        return;
      e.preventDefault();
      this.emit("input", name);
      this.emit("change", name);
    }
    onGroupBarDown(e) {
      const bar = e.target?.closest?.(".rs-group-bar");
      const group = bar?.dataset?.group;
      if (!group || !this._thumbs?.length)
        return;
      e.preventDefault();
      e.stopPropagation();
      this._dragGroup = { group, lastV: this.posToValue(e) };
      try {
        e.target.setPointerCapture?.(e.pointerId);
      } catch {
      }
    }
    onGroupBarKey(e) {
      const bar = e.target?.closest?.(".rs-group-bar");
      const group = bar?.dataset?.group;
      if (!group || !this._thumbs?.length)
        return;
      const step = this._step;
      let d = null;
      switch (e.key) {
        case "ArrowUp":
        case "ArrowRight":
          d = step;
          break;
        case "ArrowDown":
        case "ArrowLeft":
          d = -step;
          break;
        case "PageUp":
          d = step * 10;
          break;
        case "PageDown":
          d = -step * 10;
          break;
        default:
          return;
      }
      e.preventDefault();
      this.moveGroup(group, d);
      this.emit("input", `group:${group}`);
      this.emit("change", `group:${group}`);
    }
    onThumbChildrenMutated() {
      if (this._syncing || this._dragThumb || this._dragGroup)
        return;
      this.parseThumbs();
      this.paint();
    }
  };
  __decorate([
    onConnectedBodyShadow,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
  ], RangeSliderImpl.prototype, "render", null);
  __decorate([
    queryShadow("#rs-track"),
    __metadata("design:type", typeof (_a = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _a : Object)
  ], RangeSliderImpl.prototype, "track", void 0);
  __decorate([
    queryShadow("#rs-fill"),
    __metadata("design:type", typeof (_b = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _b : Object)
  ], RangeSliderImpl.prototype, "fill", void 0);
  __decorate([
    queryShadow("#rs-min"),
    __metadata("design:type", typeof (_c = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _c : Object)
  ], RangeSliderImpl.prototype, "thumbMin", void 0);
  __decorate([
    queryShadow("#rs-max"),
    __metadata("design:type", typeof (_d = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _d : Object)
  ], RangeSliderImpl.prototype, "thumbMax", void 0);
  __decorate([
    queryShadow("#rs-thumbs"),
    __metadata("design:type", typeof (_e = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _e : Object)
  ], RangeSliderImpl.prototype, "thumbBox", void 0);
  __decorate([
    onConnectedAfter,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onConnected", null);
  __decorate([
    changedAttribute("min", { type: Number }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMinChanged", null);
  __decorate([
    changedAttribute("max", { type: Number }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMaxChanged", null);
  __decorate([
    changedAttribute("step", { type: Number }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onStepChanged", null);
  __decorate([
    changedAttribute("mode"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onModeChanged", null);
  __decorate([
    changedAttribute("orientation"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onOrientationChanged", null);
  __decorate([
    changedAttribute("min-value", { type: Number }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMinValueChanged", null);
  __decorate([
    changedAttribute("max-value", { type: Number }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMaxValueChanged", null);
  __decorate([
    changedAttribute("value", { type: String }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onValueChanged", null);
  __decorate([
    eventShadow("#rs-min", "pointerdown"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_f = typeof PointerEvent !== "undefined" && PointerEvent) === "function" ? _f : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMinDown", null);
  __decorate([
    eventShadow("#rs-max", "pointerdown"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_g = typeof PointerEvent !== "undefined" && PointerEvent) === "function" ? _g : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMaxDown", null);
  __decorate([
    eventShadow("#rs-track", "pointerdown"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_h = typeof PointerEvent !== "undefined" && PointerEvent) === "function" ? _h : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onTrackDown", null);
  __decorate([
    eventWindow("pointermove"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_j = typeof PointerEvent !== "undefined" && PointerEvent) === "function" ? _j : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onDragMove", null);
  __decorate([
    eventWindow("pointerup"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onDragUp", null);
  __decorate([
    eventWindow("pointercancel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onDragCancel", null);
  __decorate([
    eventShadow("#rs-min", "keydown"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_k = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _k : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMinKey", null);
  __decorate([
    eventShadow("#rs-max", "keydown"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_l = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _l : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMaxKey", null);
  __decorate([
    event(".rs-thumb-multi", "pointerdown", { root: "shadow", delegate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_m = typeof PointerEvent !== "undefined" && PointerEvent) === "function" ? _m : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMultiThumbDown", null);
  __decorate([
    event(".rs-thumb-multi", "keydown", { root: "shadow", delegate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_o = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _o : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onMultiThumbKey", null);
  __decorate([
    event(".rs-group-bar", "pointerdown", { root: "shadow", delegate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_p = typeof PointerEvent !== "undefined" && PointerEvent) === "function" ? _p : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onGroupBarDown", null);
  __decorate([
    event(".rs-group-bar", "keydown", { root: "shadow", delegate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_q = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _q : Object]),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onGroupBarKey", null);
  __decorate([
    mutationObserverLight({ childList: true, attributes: true, subtree: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
  ], RangeSliderImpl.prototype, "onThumbChildrenMutated", null);
  RangeSliderImpl = __decorate([
    elementDefine(tagName, { window: w })
  ], RangeSliderImpl);
  return RangeSliderImpl;
};
export {
  clampThumbs,
  RangeSlider_default as default,
  nearestThumbIndex,
  resolveBound,
  snapValue,
  translateStates
};
//# sourceMappingURL=RangeSlider.js.map
